import axios from 'axios';
import { redirectToLogin } from '@/services/redirectToLogin.ts';

export const HttpService = axios.create({
  withCredentials: true,
  baseURL: import.meta.env.VITE_API_BASE_URL,
});

interface JsonSingleError {
  code?: number;
  message: string;
  localizedMessage?: string;
}

interface JsonErrorResponse {
  errors?: JsonSingleError[];
}

export interface ApiError extends Error {
  apiErrorCode?: number;
}

HttpService.interceptors.response.use(undefined, (error: unknown) => {
  if (axios.isAxiosError<JsonErrorResponse>(error)) {
    if (error.response?.status === 401) {
      redirectToLogin();
      return new Promise(() => {});
    }

    const errors = error.response?.data.errors;
    const firstError = Array.isArray(errors) ? errors[0] : undefined;
    const backendMessage = firstError?.localizedMessage ?? firstError?.message;

    if (backendMessage) {
      error.message = backendMessage;
    }
    (error as ApiError).apiErrorCode = firstError?.code;
  }

  throw error;
});
